<template>
  <div class="container">
    <h2>Tokenized Asset</h2>
    <br />
    <div class="row">
      <div class="col-md">
        <h5>Asset Name</h5>
        <form class="mt-4">
          <div class="form-group">
            <input
              v-model="asset_name"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </form>
        <br />
        <div class="row">
          <div class="col-md">
            <h5 class="text-center">Symbol</h5>
            <form class="mt-4">
              <div class="form-group">
                <input
                  id="readonly"
                  v-model="token_symbol"
                  type="text"
                  class="form-control text-center"
                  disabled
                />
              </div>
            </form>
          </div>
          <div class="col-md">
            <h5 class="text-center">Total Tokens</h5>
            <form class="mt-4">
              <div class="form-group">
                <input
                  id="readonly"
                  v-model="total_tokens"
                  type="number"
                  class="form-control text-center"
                  disabled
                />
              </div>
            </form>
          </div>
          <div class="col-md">
            <h5 class="text-center">Divisible</h5>
            <form class="mt-4">
              <div class="form-group">
                <input
                  id="readonly"
                  v-model="decimals"
                  type="text"
                  class="form-control text-center"
                  disabled
                />
              </div>
            </form>
          </div>
        </div>
        <br />
        <br />
        <div class="col-md">
          <h5>Issuer Transaction</h5>
          <form class="mt-4">
            <div class="form-group">
              <input id="readonly" type="text" class="form-control" disabled />
            </div>
            <a
              :href="'https://etherscan.io/address/' + address"
              target="_blank"
            >
              View on Etherscan</a
            >
          </form>
        </div>
      </div>
      <div class="col-md">
        <h5>ETH Address</h5>
        <form class="mt-4">
          <div class="form-group">
            <input
              v-model="address"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </form>
        <br />
        <div class="row">
          <div class="col-md-5">
            <h5 class="text-center">Token Price</h5>
            <form class="mt-4">
              <div class="form-group">
                <input
                  id="readonly"
                  v-model="token_price"
                  type="text"
                  class="form-control text-center"
                  disabled
                />
              </div>
            </form>
          </div>
          <div class="col-md">
            <h5>Accepted Currencies</h5>
            <br />
            <img
              id="eth_icon"
              class="img-fluid rounded-circle"
              src="../../../public/coins/ETH_Icon.png"
              alt="Ether coin icon"
            />
            <span>{{ currency }}</span>
          </div>
          <div class="col-md"></div>
        </div>
        <br />
        <br />
        <div class="row">
          <div class="col-md">
            <h5>Emission Date</h5>
            <form class="mt-4">
              <div class="form-group">
                <input
                  id="readonly"
                  v-model="date_emission"
                  type="date"
                  class="form-control text-center"
                  disabled
                />
              </div>
            </form>
          </div>
          <div class="col-md"></div>
          <div class="col-md"></div>
        </div>
        <br />
      </div>
    </div>
    <br />
    <br />
    <br />

    <h3>Raised Funds</h3>
    <br />
    <div class="d-flex justify-content-between">
      <div>
        <br />
        <span>0%</span>
      </div>
      <div>
        <p class="text-right">Goal</p>
        <p class="text-right">{{ goal }} {{ coinbase }}</p>
      </div>
    </div>
    <div class="progress progress-xl">
      <div
        class="progress-bar bg-success"
        role="progressbar"
        aria-valuenow="0"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 0%;"
      ></div>
    </div>
    <br />
    <div class="row">
      <div class="col-md">
        <h5>Start Date</h5>
        <form class="mt-4">
          <div class="form-group">
            <input
              id="readonly"
              v-model="start_date"
              type="date"
              class="form-control"
              disabled
            />
          </div>
        </form>
      </div>
      <div class="col-md">
        <h5>Deadline</h5>
        <form class="mt-4">
          <div class="form-group">
            <input
              id="readonly"
              v-model="deadline"
              type="date"
              class="form-control"
              disabled
            />
          </div>
        </form>
      </div>
      <div class="col-md bg-light">
        <h3 class="font-weight-bold mt-2">Raised funds</h3>
        <h3 class="ml-3">0 {{ coinbase }}</h3>
        <h5 class="ml-3 text-muted">0 {{ token_symbol }}</h5>
      </div>
    </div>
    <br />
    <br />
    <div class="text-right">
      <button
        type="button"
        class="btn btn-outline-primary btn-rounded"
        @click="toOpportunities"
      >
        <i class="fas fa-check"></i> Finish
      </button>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import * as move_tabs from './js/movetabs.js';
import * as moment from 'moment/moment';
export default {
  name: 'AssetConfirmation',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      asset_name: '',
      decimals: 0,
      currency: '',
      token_price: 0.0,
      date_emission: '',
      start_date: '',
      deadline: '',
      coinbase: '',
      goal: 0.0,
      total_tokens: 0.0,
      token_symbol: '',
      address: '',
      //'0x6e061ace13a00d87c8e892df48cecc7868b0decd67a383f50104ca25793408aa',
    };
  },
  created() {
    //get the assetID of the local storage
    if (localStorage.getItem('asset')) {
      let localasset = JSON.parse(localStorage.getItem('asset'));

      this.assetId = localasset.assetId;
      this.asset_name = localasset.assetName;
      this.total_tokens = parseFloat(localasset.total_tokens);
      this.token_symbol = localasset.token_symbol;
      this.start_date = localasset.start_date;
      this.currency = localasset.currencies;
      this.token_price = parseFloat(localasset.current_token_price);
      this.deadline = localasset.deadline;
      this.coinbase = localasset.coinbase;
      this.goal = parseFloat(localasset.goal);
      this.decimals = localasset.decimals;
    }
    this.date_emission = moment().format('YYYY-MM-DD');

    let localuser = JSON.parse(localStorage.getItem('user'));
    this.address = localuser.walletETH;
  },
  methods: {
    toOpportunities() {
      localStorage.removeItem('asset');
      window.location = '/tokens';
    },

    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 6);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    emptyFields() {
      return true;
    },
  },
};
</script>

<style>
#eth_icon {
  width: 1em;
}
</style>
